import { Component, OnInit } from '@angular/core';
import { Router } from '@angular/router';

@Component({
  selector: 'app-auth-layout',
  templateUrl: './auth-layout.component.html',
  styleUrls: ['./auth-layout.component.scss']
})
export class AuthLayoutComponent implements OnInit {
  public currentYear: number = new Date().getFullYear();
  public isCollapsed = true;

  public styleParticles: object = {};
  public paramsParticles: object = {};

  constructor(private router: Router) { }

  ngOnInit() {
    /*var html = document.getElementsByTagName("html")[0];
    html.classList.add("auth-layout");
    var body = document.getElementsByTagName("body")[0];
    body.classList.add("bg-icbeu-danger");
    this.router.events.subscribe((event) => {
      this.isCollapsed = true;
   });*/

    this.styleParticles = {
      'position': 'fixed',
      'width': '100%',
      'height': '100%',    
      'top': 0,
      'left': 0,
      'right': 0,
      'bottom': 0,
      'background': 'rgba(0, 0, 0, .3)',
      
    };

    this.paramsParticles = {
      particles: {
        number: {
          value: 100,
          density: {
            enable: true,
            value_area: 2000
          }
        },
        color: {
          value: '#fff'
        },
        shape: {
          type: 'polygon',
        },
        move: {
          random: true,
          speed: 10,
          out_mode: 'bounce'
        }
       
      }
    };
  }
  ngOnDestroy() {
    /*var html = document.getElementsByTagName("html")[0];
    html.classList.remove("auth-layout");
    var body = document.getElementsByTagName("body")[0];
    body.classList.remove("bg-icbeu-danger");*/
  }

}
